import _regeneratorRuntime from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { clear as _clear, drawConnectLine as _drawConnectLine, drawGrabLine as _drawGrabLine, drawParticle as _drawParticle, drawParticlePlugin as _drawParticlePlugin, drawPlugin as _drawPlugin, gradient, paintBase as _paintBase } from "../Utils/CanvasUtils";
import { colorToHsl, colorToRgb, getStyleFromHsl, getStyleFromRgb } from "../Utils/ColorUtils";
import { Constants } from "./Utils/Constants";
import { deepExtend } from "../Utils/Utils";
export var Canvas = /*#__PURE__*/function () {
  function Canvas(container) {
    _classCallCheck(this, Canvas);
    this.container = container;
    this.size = {
      height: 0,
      width: 0
    };
    this.context = null;
    this.generatedCanvas = false;
  }
  _createClass(Canvas, [{
    key: "init",
    value: function init() {
      this.resize();
      this.initStyle();
      this.initCover();
      this.initTrail();
      this.initBackground();
      this.paint();
    }
  }, {
    key: "loadCanvas",
    value: function loadCanvas(canvas) {
      var _a;
      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }
      this.generatedCanvas = canvas.dataset && Constants.generatedAttribute in canvas.dataset ? canvas.dataset[Constants.generatedAttribute] === "true" : this.generatedCanvas;
      this.element = canvas;
      this.originalStyle = deepExtend({}, this.element.style);
      this.size.height = canvas.offsetHeight;
      this.size.width = canvas.offsetWidth;
      this.context = this.element.getContext("2d");
      this.container.retina.init();
      this.initBackground();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this = this;
      var _a;
      if (this.generatedCanvas) {
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
      }
      this.draw(function (ctx) {
        _clear(ctx, _this.size);
      });
    }
  }, {
    key: "paint",
    value: function paint() {
      var _this2 = this;
      var options = this.container.actualOptions;
      this.draw(function (ctx) {
        if (options.backgroundMask.enable && options.backgroundMask.cover) {
          _clear(ctx, _this2.size);
          _this2.paintBase(_this2.coverColorStyle);
        } else {
          _this2.paintBase();
        }
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this3 = this;
      var options = this.container.actualOptions,
        trail = options.particles.move.trail;
      if (options.backgroundMask.enable) {
        this.paint();
      } else if (trail.enable && trail.length > 0 && this.trailFillColor) {
        this.paintBase(getStyleFromRgb(this.trailFillColor, 1 / trail.length));
      } else {
        this.draw(function (ctx) {
          _clear(ctx, _this3.size);
        });
      }
    }
  }, {
    key: "windowResize",
    value: function () {
      var _windowResize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var container, needsRefresh, _iterator, _step, _step$value, plugin;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.element) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                this.resize();
                container = this.container, needsRefresh = container.updateActualOptions();
                container.particles.setDensity();
                _iterator = _createForOfIteratorHelper(container.plugins);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _step$value = _slicedToArray(_step.value, 2), plugin = _step$value[1];
                    if (plugin.resize !== undefined) {
                      plugin.resize();
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                if (!needsRefresh) {
                  _context.next = 10;
                  break;
                }
                _context.next = 10;
                return container.refresh();
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function windowResize() {
        return _windowResize.apply(this, arguments);
      }
      return windowResize;
    }()
  }, {
    key: "resize",
    value: function resize() {
      if (!this.element) {
        return;
      }
      var container = this.container,
        pxRatio = container.retina.pixelRatio,
        size = container.canvas.size,
        newSize = {
          width: this.element.offsetWidth * pxRatio,
          height: this.element.offsetHeight * pxRatio
        };
      if (newSize.height === size.height && newSize.width === size.width && newSize.height === this.element.height && newSize.width === this.element.width) {
        return;
      }
      var oldSize = Object.assign({}, size);
      this.element.width = size.width = this.element.offsetWidth * pxRatio;
      this.element.height = size.height = this.element.offsetHeight * pxRatio;
      if (this.container.started) {
        this.resizeFactor = {
          width: size.width / oldSize.width,
          height: size.height / oldSize.height
        };
      }
    }
  }, {
    key: "drawConnectLine",
    value: function drawConnectLine(p1, p2) {
      var _this4 = this;
      this.draw(function (ctx) {
        var _a;
        var lineStyle = _this4.lineStyle(p1, p2);
        if (!lineStyle) {
          return;
        }
        var pos1 = p1.getPosition(),
          pos2 = p2.getPosition();
        _drawConnectLine(ctx, (_a = p1.retina.linksWidth) !== null && _a !== void 0 ? _a : _this4.container.retina.linksWidth, lineStyle, pos1, pos2);
      });
    }
  }, {
    key: "drawGrabLine",
    value: function drawGrabLine(particle, lineColor, opacity, mousePos) {
      var container = this.container;
      this.draw(function (ctx) {
        var _a;
        var beginPos = particle.getPosition();
        _drawGrabLine(ctx, (_a = particle.retina.linksWidth) !== null && _a !== void 0 ? _a : container.retina.linksWidth, beginPos, mousePos, lineColor, opacity);
      });
    }
  }, {
    key: "drawParticle",
    value: function drawParticle(particle, delta) {
      var _this5 = this;
      var _a, _b, _c, _d, _e, _f;
      if (particle.spawning || particle.destroyed) {
        return;
      }
      var radius = particle.getRadius();
      if (radius <= 0) {
        return;
      }
      var pfColor = particle.getFillColor(),
        psColor = (_a = particle.getStrokeColor()) !== null && _a !== void 0 ? _a : pfColor;
      if (!pfColor && !psColor) {
        return;
      }
      var _this$getPluginPartic = this.getPluginParticleColors(particle),
        _this$getPluginPartic2 = _slicedToArray(_this$getPluginPartic, 2),
        fColor = _this$getPluginPartic2[0],
        sColor = _this$getPluginPartic2[1];
      if (!fColor || !sColor) {
        if (!fColor) {
          fColor = pfColor ? pfColor : undefined;
        }
        if (!sColor) {
          sColor = psColor ? psColor : undefined;
        }
      }
      var options = this.container.actualOptions,
        zIndexOptions = particle.options.zIndex,
        zOpacityFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.opacityRate),
        opacity = (_d = (_b = particle.bubble.opacity) !== null && _b !== void 0 ? _b : (_c = particle.opacity) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 1,
        strokeOpacity = (_f = (_e = particle.stroke) === null || _e === void 0 ? void 0 : _e.opacity) !== null && _f !== void 0 ? _f : opacity,
        zOpacity = opacity * zOpacityFactor,
        zStrokeOpacity = strokeOpacity * zOpacityFactor;
      var colorStyles = {
        fill: fColor ? getStyleFromHsl(fColor, zOpacity) : undefined
      };
      colorStyles.stroke = sColor ? getStyleFromHsl(sColor, zStrokeOpacity) : colorStyles.fill;
      this.draw(function (ctx) {
        var zSizeFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.sizeRate),
          container = _this5.container;
        var _iterator2 = _createForOfIteratorHelper(container.particles.updaters),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var updater = _step2.value;
            if (updater.beforeDraw) {
              updater.beforeDraw(particle);
            }
            if (updater.getColorStyles) {
              var _updater$getColorStyl = updater.getColorStyles(particle, ctx, radius, zOpacity),
                fill = _updater$getColorStyl.fill,
                stroke = _updater$getColorStyl.stroke;
              if (fill) {
                colorStyles.fill = fill;
              }
              if (stroke) {
                colorStyles.stroke = stroke;
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        _drawParticle(container, ctx, particle, delta, colorStyles, options.backgroundMask.enable, options.backgroundMask.composite, radius * zSizeFactor, zOpacity, particle.options.shadow);
        var _iterator3 = _createForOfIteratorHelper(container.particles.updaters),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _updater = _step3.value;
            if (_updater.afterDraw) {
              _updater.afterDraw(particle);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      });
    }
  }, {
    key: "drawPlugin",
    value: function drawPlugin(plugin, delta) {
      this.draw(function (ctx) {
        _drawPlugin(ctx, plugin, delta);
      });
    }
  }, {
    key: "drawParticlePlugin",
    value: function drawParticlePlugin(plugin, particle, delta) {
      this.draw(function (ctx) {
        _drawParticlePlugin(ctx, plugin, particle, delta);
      });
    }
  }, {
    key: "initBackground",
    value: function initBackground() {
      var options = this.container.actualOptions,
        background = options.background,
        element = this.element,
        elementStyle = element === null || element === void 0 ? void 0 : element.style;
      if (!elementStyle) {
        return;
      }
      if (background.color) {
        var color = colorToRgb(background.color);
        elementStyle.backgroundColor = color ? getStyleFromRgb(color, background.opacity) : "";
      } else {
        elementStyle.backgroundColor = "";
      }
      elementStyle.backgroundImage = background.image || "";
      elementStyle.backgroundPosition = background.position || "";
      elementStyle.backgroundRepeat = background.repeat || "";
      elementStyle.backgroundSize = background.size || "";
    }
  }, {
    key: "draw",
    value: function draw(cb) {
      if (!this.context) {
        return;
      }
      return cb(this.context);
    }
  }, {
    key: "initCover",
    value: function initCover() {
      var options = this.container.actualOptions,
        cover = options.backgroundMask.cover,
        color = cover.color,
        coverRgb = colorToRgb(color);
      if (coverRgb) {
        var coverColor = {
          r: coverRgb.r,
          g: coverRgb.g,
          b: coverRgb.b,
          a: cover.opacity
        };
        this.coverColorStyle = getStyleFromRgb(coverColor, coverColor.a);
      }
    }
  }, {
    key: "initTrail",
    value: function initTrail() {
      var options = this.container.actualOptions,
        trail = options.particles.move.trail,
        fillColor = colorToRgb(trail.fillColor);
      if (fillColor) {
        var _trail = options.particles.move.trail;
        this.trailFillColor = {
          r: fillColor.r,
          g: fillColor.g,
          b: fillColor.b,
          a: 1 / _trail.length
        };
      }
    }
  }, {
    key: "getPluginParticleColors",
    value: function getPluginParticleColors(particle) {
      var fColor, sColor;
      var _iterator4 = _createForOfIteratorHelper(this.container.plugins),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
            plugin = _step4$value[1];
          if (!fColor && plugin.particleFillColor) {
            fColor = colorToHsl(plugin.particleFillColor(particle));
          }
          if (!sColor && plugin.particleStrokeColor) {
            sColor = colorToHsl(plugin.particleStrokeColor(particle));
          }
          if (fColor && sColor) {
            break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return [fColor, sColor];
    }
  }, {
    key: "initStyle",
    value: function initStyle() {
      var element = this.element,
        options = this.container.actualOptions;
      if (!element) {
        return;
      }
      var originalStyle = this.originalStyle;
      if (options.fullScreen.enable) {
        this.originalStyle = deepExtend({}, element.style);
        element.style.setProperty("position", "fixed", "important");
        element.style.setProperty("z-index", options.fullScreen.zIndex.toString(10), "important");
        element.style.setProperty("top", "0", "important");
        element.style.setProperty("left", "0", "important");
        element.style.setProperty("width", "100%", "important");
        element.style.setProperty("height", "100%", "important");
      } else if (originalStyle) {
        element.style.position = originalStyle.position;
        element.style.zIndex = originalStyle.zIndex;
        element.style.top = originalStyle.top;
        element.style.left = originalStyle.left;
        element.style.width = originalStyle.width;
        element.style.height = originalStyle.height;
      }
      for (var key in options.style) {
        if (!key || !options.style) {
          continue;
        }
        var value = options.style[key];
        if (!value) {
          continue;
        }
        element.style.setProperty(key, value, "important");
      }
    }
  }, {
    key: "paintBase",
    value: function paintBase(baseColor) {
      var _this6 = this;
      this.draw(function (ctx) {
        _paintBase(ctx, _this6.size, baseColor);
      });
    }
  }, {
    key: "lineStyle",
    value: function lineStyle(p1, p2) {
      var _this7 = this;
      return this.draw(function (ctx) {
        var options = _this7.container.actualOptions,
          connectOptions = options.interactivity.modes.connect;
        return gradient(ctx, p1, p2, connectOptions.links.opacity);
      });
    }
  }]);
  return Canvas;
}();